const polyfills = [
    {
        description: 'Add window.location.origin in IE < 11',
        enabled: true,
        fn: () => {
            const loc = window.location;
            if (!loc.origin) {
                loc.origin = `${loc.protocol}//${loc.hostname}${
                    loc.port ? `:${loc.port}` : ''
                }`;
            }
        },
    },
];

function applyPolyfills() {
    polyfills.forEach((polyfill) => {
        if (polyfill.enabled) {
            polyfill.fn();
        }
    });
}

export default applyPolyfills;
